import { playSound } from '../sounds/play-sound';

export class AedStore {
    private aedSoundPlayed: Record<number, true> = {};
    private setAedSoundPlayed(eventId: number): void {
        this.aedSoundPlayed[eventId] = true;
    }
    public playSoundForEvent(eventId: number): void {
        if (this.aedSoundPlayed[eventId]) {
            return;
        }
        this.setAedSoundPlayed(eventId);
        playSound('aed-attempting-accepting');
    }
}

export const aedStore = new AedStore();
